import React from "react";
import { map, pipe, sort, values } from "ramda";
import { connect } from "react-redux";
import { showFacetDialog } from "browse-media/redux/browseMediaActions";
import FacetMenu from "components/faceted-search/FacetMenu";
import FacetMenuItem from "components/faceted-search/FacetMenuItem";

const getSortedFacets = pipe(
  values,
  sort((a, b) => {
    const aName = a.displayName ? a.displayName : a.name;
    const bName = b.displayName ? b.displayName : b.name;
    aName.localeCompare(bName);
  }),
);

const BrowseMediaFacetMenu = ({ availableFacets, onClickFacet }) => (
  <FacetMenu>
    {map(
      facet => (
        <FacetMenuItem
          key={facet.name}
          value={facet.name}
          caption={facet.displayName}
          onClick={() => onClickFacet(facet.name)}
        />
      ),
      getSortedFacets(availableFacets),
    )}
  </FacetMenu>
);

const mapStateToProps = state => {
  const { availableFacets } = state.browseMedia;

  return {
    availableFacets,
  };
};

const mapDispatchToProps = dispatch => ({
  onClickFacet: facet => dispatch(showFacetDialog(facet)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrowseMediaFacetMenu);
